import React from 'react';
import { Checkbox, FormControl, FormControlLabel, FormHelperText } from '@carrotfertility/carotene-core';
import { Controller, useFormContext } from 'react-hook-form';
import { getFormInputState } from './form-utils';
import { FormCheckBoxProps } from './form-types';

export function FormCheckbox({
    name,
    label,
    controllerProps,
    helperText,
    error,
    ...otherProps
}: FormCheckBoxProps): JSX.Element {
    const {
        control,
        formState: { errors, isSubmitting },
        getValues,
    } = useFormContext();

    const labelId = name + '-label';
    const helperTextId = name + '-helper-text';

    const { error: hasError, helperText: helperTextValue } = getFormInputState({ name, errors, error, helperText });

    return (
        <Controller
            {...(controllerProps || {})}
            {...{ control, name }}
            render={({ field: { onChange } }) => (
                <FormControl error={hasError} disabled={isSubmitting || otherProps.disabled}>
                    <FormControlLabel
                        required={otherProps.required ? otherProps.required : Boolean(controllerProps?.rules?.required)}
                        {...otherProps}
                        label={label}
                        control={
                            <Checkbox
                                {...otherProps}
                                aria-describedby={helperTextId}
                                aria-labelledby={labelId}
                                id={name}
                                onChange={onChange}
                                checked={getValues(name)}
                                color={hasError ? 'error' : 'secondary'}
                            />
                        }
                    />
                    <FormHelperText id={helperTextId}>{helperTextValue}</FormHelperText>
                </FormControl>
            )}
        />
    );
}
